import {Splide} from '@splidejs/splide';

export const mvSlider = () => {
  const mvSlider = document.querySelector('.js-mv-slider');
  if (!mvSlider) return;

  const splide = new Splide(mvSlider, {
    type: 'fade',
    rewind: true,
    perPage: 1,
    perMove: 1,
    gap: '1rem',
    autoplay: true,
    interval: 6000,
    speed: 3000,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    classes: {
      pagination: 'mv-slider__pagination',
      page: 'mv-slider__pagination-page',
    }
  });

  splide.mount();
};

export default mvSlider;
